import { render, staticRenderFns } from "./LicitacaoEsclarecimentoAnexo.vue?vue&type=template&id=623b8cb8&scoped=true"
import script from "./LicitacaoEsclarecimentoAnexo.vue?vue&type=script&lang=js"
export * from "./LicitacaoEsclarecimentoAnexo.vue?vue&type=script&lang=js"
import style0 from "./LicitacaoEsclarecimentoAnexo.vue?vue&type=style&index=0&id=623b8cb8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b8cb8",
  null
  
)

export default component.exports